import { forwardRef, type Ref, type SVGProps } from "react";
const IconPlayOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M26 16 6 28V4zM6 2a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2 2 2 0 0 0 1-.3l20-12a2 2 0 0 0 0-3.4L7 2.3A2 2 0 0 0 6 2" /></svg>;
const ForwardRef = forwardRef(IconPlayOutlineSVG);
ForwardRef.displayName = "IconPlayOutline";
export { ForwardRef as IconPlayOutline };